/**
 * Calendar dates as the desk sees them — LOCAL time, `YYYY-MM-DD`.
 *
 * ⚠️ NOT `toISOString().slice(0, 10)`, which is the UTC date. The branches run at UTC+3, so
 * between local midnight and 03:00 that gives YESTERDAY: a payment taken at 00:14 on the 5th
 * defaulted its posting date to the 4th. And a `Date` built at local midnight
 * (`new Date(y, m, 1)`) is 21:00 the previous day in UTC, so a "month start" built that way is
 * wrong every day, not just after midnight.
 */
export function toLocalDateKey(date: Date): string {
  const pad = (value: number) => String(value).padStart(2, "0");

  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

/** Today's local date, `YYYY-MM-DD`. */
export function localToday(): string {
  return toLocalDateKey(new Date());
}
